<template>
  <div>
    <base-header
      class="pb-6"
      style="background-color: #f8f9fe !important">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-#465370 d-inline-block mb-0">{{ $route.name }}</h6>
        </div>
      </div>
      <div v-if="meta && meta.serviceRequestNumber">
        <h4> Service Request Number - {{ meta.serviceRequestNumber }}</h4>
      </div>
      <div v-if="meta && meta.averagePoints">
        <h4> Vendor's Average Points For This Request - {{ meta.averagePoints }} <i class="el-icon-coin
"></i> </h4>

      </div>
    </base-header>
  </div>
</template>
<script>
export default {
  props:{
    buttons : {
      type : Array,
      default :() => []
    },
    meta: {
      type: Object,
      default:() => {

      }
    }
  },
    data : () => {
        return {

        }
    },
    methods : {
      showFilters() {
        this.$emit('showFilters');
      },
    }
}
</script>
